module.exports = __webpack_public_path__ + "img/fast-delivery-2.fb4e546.svg";